import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/styles";
import { useParams, useLocation } from "react-router-dom";
import classNames from "classnames";
import { connectGeoSearch } from "react-instantsearch-dom";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { setup, isSupported } from "@loomhq/loom-sdk";
import { oembed } from "@loomhq/loom-embed";
import AddIcon from "@material-ui/icons/Add";

import Navbar from "./DemoNavbar";
import Map from "./Map";
import Places from "./Places";
//import results from '../data/hits.json';
import useGoogleMap from "./useGoogleMap";
import useCurrentUser from "./useCurrentUser";

const BUTTON_ID = "loom-sdk-button";
//const API_KEY = "92cbd575-9337-46e5-81ed-2fbeca7d157e";
const API_KEY = "946998be-e5c9-41b8-8c29-3ed1a2e838e2";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      overscrollBehaviorX: "none",
    },
  },
  root: {},
  appBar: {
    display: "flex",
    alignItems: "center",
  },
  content: {
    position: "relative",
  },
  right: {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 375,
    },
    [theme.breakpoints.up("md")]: {
      width: 457,
    },
    [theme.breakpoints.up("lg")]: {
      width: 700,
    },
    right: 0,
    position: "absolute",
    backgroundColor: "white",
  },
  left: {
    top: 56,
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      top: 48,
    },
    bottom: 0,
    width: "100%",
    position: "fixed",
    [theme.breakpoints.up("sm")]: {
      width: "calc(100% - 375px)",
      top: 64,
    },
    [theme.breakpoints.up("md")]: {
      width: "calc(100% - 457px)",
    },
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% - 700px)",
    },
  },
  rightHidden: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  toolbar: theme.mixins.toolbar,
  mapButton: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  button: {
    [theme.breakpoints.up("sm")]: {
      left: "calc(40% - 32px)",
    },
    position: "fixed",
    bottom: 0,
    left: "calc(50% - 32px)",
    zIndex: 100,
    marginBottom: theme.spacing(8),
  },
  addButton: {
    display: "none",
  },
  recordButton: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
    position: "fixed",
    bottom: 0,
    left: "calc(50% - 32px)",
    zIndex: 100,
    marginBottom: theme.spacing(8),
  },
  input: {
    width: 400,
    backgroundColor: "white",
    borderRadius: 7,
    borderColor: "white",
    padding: 0,
  },
}));

function Main(props) {
  const classes = useStyles(props);
  let { refine, hits, searchClient, currentRefinement } = props;
  //let hits = results.results[0].hits;
  let params = useParams();
  let routeLocation = useLocation();

  const [videoHTML, setVideoHTML] = React.useState("");
  const [latLng, setlatLng] = React.useState({});
  const [name, setName] = React.useState("");
  const [videoUrl, setVideoUrl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  let addButtonEl = React.useRef(null);
  const [currentUser] = useCurrentUser();
  const [value, setValue] = React.useState(params.search || "");
  const [showMap, setShowMap] = React.useState(false);
  const [mapInstance] = useGoogleMap();

  const onRightClick = (e) => {
    console.log(e.latLng.lat(), e.latLng.lng());
    setlatLng({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    addButtonEl.current.click();
    //    setOpen(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const onSendToAlgolia = async (e) => {
    e.preventDefault();
    console.log("send to algolia");
    const objects = [
      {
        _geoloc: latLng,
        photoUrl: currentUser?.photoURL,
        videoUrl: videoUrl,
        name: name,
        createdAt: new Date(),
      },
    ];

    let resp = await fetch(process.env.REACT_APP_FUNCTIONS, {
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        objects,
      }),
      method: "POST",
    });
    // Hacky way to rerender
    if (mapInstance && mapInstance.map) {
      let bounds = mapInstance.map.getBounds();
      mapInstance.map.fitBounds(bounds);
      refine({
        northEast: bounds.getNorthEast().toJSON(),
        southWest: bounds.getSouthWest().toJSON(),
      });
    }
    setOpen(false);
    setName("");
  };

  React.useEffect(() => {
    async function setupLoom() {
      const { supported, error } = await isSupported();

      if (!supported) {
        setVideoHTML(`Error: ${error}`);
        console.warn(`Error setting up Loom: ${error}`);
        return;
      }

      //const button = document.getElementById(BUTTON_ID);

      if (!addButtonEl) {
        return;
      }

      const { configureButton } = await setup({
        apiKey: API_KEY,
      });

      const sdkButton = configureButton({ element: addButtonEl.current });

      sdkButton.on("insert-click", async (video) => {
        handleClickOpen();
        const { html } = await oembed(video.sharedUrl, { width: 400 });
        setVideoHTML(html);
        setVideoUrl(video.embedUrl);
      });
    }

    setupLoom();
  }, []);

  React.useEffect(() => {
    console.log("search", props, routeLocation);
    if (
      !props.location ||
      !props.location.state ||
      !props.location.state.option ||
      !mapInstance ||
      !mapInstance.map
    ) {
      return;
    }
    mapInstance.places.getDetails(
      {
        fields: ["geometry"],
        placeId: props.location.state.option.place_id,
      },
      (result) => {
        if (!result) return;
        let bounds = result.geometry.viewport;
        if (mapInstance && mapInstance.map) {
          mapInstance.map.fitBounds(bounds);
          refine({
            northEast: bounds.getNorthEast().toJSON(),
            southWest: bounds.getSouthWest().toJSON(),
          });
        }
      }
    );
  }, [mapInstance]);

  const [highlightPlace, setHighlightPlace] = useState(null);

  const [selectedPlace, setSelectedPlace] = useState(null);
  let listings = hits;
  let location = value;
  if (value) {
    location = value.description ? value.description : value.replace(/-/g, " ");
  }

  return (
    <div className={classes.root}>
      <Navbar refine={refine} value={value} setValue={setValue} />
      <div className={classes.content}>
        <div className={classes.left}>
          <Map
            listings={listings}
            onRightClick={onRightClick}
            refine={refine}
            selectedPlace={selectedPlace}
            setSelectedPlace={setSelectedPlace}
            setShowMap={setShowMap}
            highlightPlace={highlightPlace}
          />
        </div>
        <div
          className={classNames(classes.right, showMap && classes.rightHidden)}
        >
          <div className={classes.toolbar} />
          <Places
            listings={listings}
            attribute={"spaces.price"}
            selectedPlace={selectedPlace}
            setSelectedPlace={setSelectedPlace}
            setHighlightPlace={setHighlightPlace}
          />
        </div>
      </div>
      <div className={classes.button}>
        <Button
          className={classes.mapButton}
          color="primary"
          variant="contained"
          onClick={() => setShowMap(!showMap)}
        >
          {showMap ? "List" : "Map"}
        </Button>
        <Button
          id={BUTTON_ID}
          variant="contained"
          color="primary"
          className={classes.addButton}
          ref={addButtonEl}
        >
          <AddIcon />
        </Button>
      </div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add a video
        </DialogTitle>
        <form onSubmit={onSendToAlgolia}>
          <DialogContent dividers>
            <TextField
              required
              id="outlined-basic"
              label="name"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <div className={classes.dialog}>
              <div dangerouslySetInnerHTML={{ __html: videoHTML }}></div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus type="submit" color="primary">
              Save changes
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
export default connectGeoSearch(Main);
